import React, { useEffect, useState } from 'react';

import "./Rol.css";

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RolColumnList } from './RolConstants';
import { fetchGetModuloList } from '../../reducers/moduloSlice';
import { fetchGetPermisosByRol, fetchUpdateBatchRol_permiso } from '../../reducers/rol_permisoSlice';

function Rol(props) {
    const { rolId } = props;

    const [selectedRol, setSelectedRol] = useState();
    const [selectedModule, setSelectedModule] = useState();
    const [modulePermissions, setModulePermissions] = useState([]);


    const moduleData = useSelector((state) => state.rol);
    const moduloList = useSelector(state => state.modulo.moduloList);

    const { t } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!moduloList || moduloList.length === 0) {
            dispatch(fetchGetModuloList());
        }
    });

    useEffect(() => {
        if (rolId) {
            const selRol = moduleData?.rolList?.find(ad => ad.id === rolId);
            setSelectedRol(selRol);
            updatePermissionsList(rolId);
        }
    }, [rolId]);

    const updatePermissionsList = async (rol_id) => {
        const response = await fetchGetPermisosByRol(rol_id);
        setModulePermissions(response.rol_permisoList);
    }

    const handleChangePermission = (evt) => {
        const currenteMP = [...modulePermissions];
        const selPerms = currenteMP?.find(mp => mp.modulo_id === selectedModule && mp.rol_id === rolId);
        if (selPerms) {
            if (selPerms.id) {
                if (!selPerms[`${evt.target.name}_ori`]) {
                    selPerms[`${evt.target.name}_ori`] = selPerms[evt.target.name];
                }
            }
            selPerms[evt.target.name] = evt.target.checked;
        } else {
            currenteMP.push({ modulo_id: selectedModule, rol_id: rolId, [evt.target.name]: evt.target.checked });
        }

        setModulePermissions(currenteMP);
    }

    const handleUpdate = async () => {
        const toSend = [];
        for await (const perm of modulePermissions) {
            if (perm.id) {
                if (!havePermission(perm)) {
                    toSend.push({ ...perm, action: 'del' })
                } else {
                    if (haveChanges(perm)) {
                        toSend.push({ ...perm, action: 'upd' })
                    }
                }
            } else {
                if (havePermission(perm)) {
                    toSend.push({ ...perm, action: 'ins' })
                }
            }
        }

        const response = await fetchUpdateBatchRol_permiso({ permisos: toSend });
    }

    const havePermission = (perm) => {
        return perm.listar || perm.crear || perm.leer || perm.editar || perm.borrar;
    }

    const haveChanges = (perm) => {
        return (perm.listar_ori !== undefined && perm.listar_ori != perm.listar) ||
            (perm.crear_ori !== undefined && perm.crear_ori != perm.crear) ||
            (perm.leer_ori !== undefined && perm.leer_ori != perm.leer) ||
            (perm.editar_ori !== undefined && perm.editar_ori != perm.editar) ||
            (perm.borrar_ori !== undefined && perm.borrar_ori != perm.borrar);
    }

    const renderItem = (ccl) => {
        return (
            <div className='item' key={`info-item-${ccl.dbname}`}>
                <div className='title'>{t(ccl.label)}:</div>
                <div className='content'>{selectedRol[ccl.dbname]}</div>
            </div>
        )
    }

    const renderPermissions = () => {
        const selPerms = modulePermissions?.find(mp => mp.modulo_id === selectedModule && mp.rol_id === rolId);
        return (
            <>
                <div className="form-check" >
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`permission_list_${selectedRol?.nombre}_${selectedModule}`}
                        name='listar'
                        onChange={handleChangePermission}
                        checked={!!selPerms?.listar}
                    /><label className="form-check-label" htmlFor={`permission_list_${selectedRol?.nombre}_${selectedModule}`}> {t("LISTAR")} </label>
                </div>
                <div className="form-check" >
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`permission_create_${selectedRol?.nombre}_${selectedModule}`}
                        name='crear'
                        onChange={handleChangePermission}
                        checked={!!selPerms?.crear}
                    /><label className="form-check-label" htmlFor={`permission_create_${selectedRol?.nombre}_${selectedModule}`}> {t("CREAR")} </label>
                </div>
                <div className="form-check" >
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`permission_read_${selectedRol?.nombre}_${selectedModule}`}
                        name='leer'
                        onChange={handleChangePermission}
                        checked={!!selPerms?.leer}
                    /><label className="form-check-label" htmlFor={`permission_read_${selectedRol?.nombre}_${selectedModule}`}> {t("LEER")} </label>
                </div>
                <div className="form-check" >
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`permission_edit_${selectedRol?.nombre}_${selectedModule}`}
                        name='editar'
                        onChange={handleChangePermission}
                        checked={!!selPerms?.editar}
                    /><label className="form-check-label" htmlFor={`permission_edit_${selectedRol?.nombre}_${selectedModule}`}> {t("EDITAR")} </label>
                </div>
                <div className="form-check" >
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`permission_delete_${selectedRol?.nombre}_${selectedModule}`}
                        name='borrar'
                        onChange={handleChangePermission}
                        checked={!!selPerms?.borrar}
                    /><label className="form-check-label" htmlFor={`permission_delete_${selectedRol?.nombre}_${selectedModule}`}> {t("BORRAR")} </label>
                </div>
            </>
        )
    }

    return (
        <div
            className="modal"
            id={`rol_detail_modal`}
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog  modal-xl modal-administrator" >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="backDropModalTitle">{t("rol")}: {selectedRol?.nombre}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className='module-info-container'>
                            <div className='module-info-data' >
                                {
                                    selectedRol && RolColumnList().filter(ccl => ccl.form === true).map(ccl => (renderItem(ccl)))
                                }
                            </div>
                            <div className='rol-info-permisos'>
                                <div className='box-title'>
                                    {t('PERMISOS')}
                                </div>
                                <div className='box-content'>
                                    <div className='modulos'>
                                        <div className='rol-titles'>modulos</div>
                                        <div className='rol-modulo-list'>
                                            {
                                                moduloList?.map(ml => (
                                                    <div
                                                        key={`rol_module_${ml.id}`}
                                                        className={`item ${selectedModule === ml.id ? 'selected' : ''} ${!!modulePermissions?.find(mp => mp.modulo_id === ml.id && mp.rol_id === rolId) ? 'with-permissions' : ''
                                                            }`}
                                                        onClick={() => { setSelectedModule(ml.id) }}
                                                    >
                                                        {ml.nombre}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    <div className='modulos'>
                                        <div className='rol-titles'>permisos</div>
                                        {
                                            selectedModule && <div className='rol-modulo-permisos'>{renderPermissions()}</div>
                                        }

                                    </div>
                                </div>
                                <div className='box-button'>
                                    <div className='btn btn-primary' onClick={handleUpdate}>Actualizar</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Rol;